var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "Loading",
            {
              attrs: {
                visible: _vm.loading,
                message: "Caricamento spedizione...",
              },
            },
            [
              _c(
                "div",
                [
                  _vm.spedizione && _vm.spedizione != null
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _vm.inModifica
                                ? _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-title",
                                        { attrs: { "primary-title": "" } },
                                        [_vm._v(" Modifica spedizione ")]
                                      ),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-row",
                                            { staticClass: "flex" },
                                            [
                                              _c("v-text-field", {
                                                staticClass: "col-4",
                                                attrs: {
                                                  label: "Numero spedizione",
                                                },
                                                model: {
                                                  value:
                                                    _vm.spedizioneInEdit
                                                      .numeroDDT,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.spedizioneInEdit,
                                                      "numeroDDT",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "spedizioneInEdit.numeroDDT",
                                                },
                                              }),
                                              _c("v-text-field", {
                                                staticClass: "col-4",
                                                attrs: {
                                                  label: "Numero colli",
                                                  type: "number",
                                                },
                                                model: {
                                                  value:
                                                    _vm.spedizioneInEdit
                                                      .numeroColli,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.spedizioneInEdit,
                                                      "numeroColli",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "spedizioneInEdit.numeroColli",
                                                },
                                              }),
                                              _c(
                                                "v-menu",
                                                {
                                                  ref: "newSpedizioneDateMenu",
                                                  attrs: {
                                                    "offset-y": "",
                                                    transition:
                                                      "scale-transition",
                                                    "close-on-content-click": false,
                                                    "max-width": "290px",
                                                    "min-width": "90px",
                                                    "nudge-right": 40,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-text-field",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "col-4",
                                                                  attrs: {
                                                                    clearable:
                                                                      "",
                                                                    label:
                                                                      "Data spedizione",
                                                                    "persistent-hint":
                                                                      "",
                                                                    "prepend-icon":
                                                                      "mdi-calendar",
                                                                  },
                                                                  on: {
                                                                    blur: function (
                                                                      $event
                                                                    ) {
                                                                      _vm.inEditSpedizioneDataSpedizione =
                                                                        _vm.parseDate(
                                                                          _vm.inEditSpedizioneDataSpedizioneFormatted
                                                                        )
                                                                    },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.inEditSpedizioneDataSpedizioneFormatted,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.inEditSpedizioneDataSpedizioneFormatted =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "inEditSpedizioneDataSpedizioneFormatted",
                                                                  },
                                                                },
                                                                on
                                                              )
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2721162722
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.inEditSpedizioneDateMenu,
                                                    callback: function ($$v) {
                                                      _vm.inEditSpedizioneDateMenu =
                                                        $$v
                                                    },
                                                    expression:
                                                      "inEditSpedizioneDateMenu",
                                                  },
                                                },
                                                [
                                                  _c("v-date-picker", {
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.inEditSpedizioneDateMenu = false
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.inEditSpedizioneDataSpedizione,
                                                      callback: function ($$v) {
                                                        _vm.inEditSpedizioneDataSpedizione =
                                                          $$v
                                                      },
                                                      expression:
                                                        "inEditSpedizioneDataSpedizione",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-row", [
                                            _c(
                                              "div",
                                              { staticClass: "col-4" },
                                              [
                                                _c("v-select", {
                                                  attrs: {
                                                    filled: "",
                                                    items: _vm.statiSpedizione,
                                                    label: "Stato",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.spedizioneInEdit
                                                        .stato,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.spedizioneInEdit,
                                                        "stato",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "spedizioneInEdit.stato",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]),
                                          _c(
                                            "v-row",
                                            { staticClass: "flex" },
                                            [
                                              _c("v-textarea", {
                                                staticClass: "col-12",
                                                attrs: {
                                                  name: "in-edit-spedizione-note",
                                                  label: "Note",
                                                },
                                                model: {
                                                  value:
                                                    _vm.spedizioneInEdit.note,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.spedizioneInEdit,
                                                      "note",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "spedizioneInEdit.note",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            {
                                              staticClass:
                                                "flex justify-center",
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: { color: "success" },
                                                  on: {
                                                    click:
                                                      _vm.aggiornaSpedizione,
                                                  },
                                                },
                                                [_vm._v("Salva")]
                                              ),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { color: "secondary" },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.inModifica = false
                                                    },
                                                  },
                                                },
                                                [_vm._v("Annulla")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-title",
                                        { attrs: { "primary-title": "" } },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row align-baseline",
                                                },
                                                [
                                                  !_vm.isInBarCodeAcquisitionMode
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            ripple: "",
                                                          },
                                                          on: {
                                                            click: _vm.modifica,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "pa-1",
                                                              attrs: {
                                                                size: "25",
                                                                color:
                                                                  "grey lighten-1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-pencil"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticClass:
                                                        "headline mb-0",
                                                    },
                                                    [
                                                      _vm._v("SPEDIZIONE NR: "),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.spedizione
                                                              .numeroDDT
                                                          ) + " "
                                                        ),
                                                      ]),
                                                      _vm._v(" DEL "),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatDate"
                                                            )(
                                                              _vm.spedizione
                                                                .dataDDT
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "text-truncate",
                                                },
                                                [
                                                  _vm._v("DATA CREAZIONE: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatDateTime(
                                                          _vm.spedizione
                                                            .dataOraCreazione
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "text-truncate",
                                                },
                                                [
                                                  _vm._v("MITTENTE: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.spedizione
                                                          .ragioneSocialeMittente
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "text-truncate",
                                                },
                                                [
                                                  _vm._v("DESTINATARIO: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.spedizione
                                                          .ragioneSocialeDestinatario
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "text-truncate",
                                                },
                                                [
                                                  _vm._v("NUMERO COLLI: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.spedizione
                                                          .numeroColli
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c("br"),
                                              _vm.totaliSpedizioni
                                                ? _c("div", [
                                                    _c("div", [
                                                      _vm._v(
                                                        "TOTALI SPEDIZIONE: "
                                                      ),
                                                      _c(
                                                        "strong",
                                                        {
                                                          style: {
                                                            color:
                                                              _vm
                                                                .totaliSpedizioni
                                                                .color,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .totaliSpedizioni
                                                                .totSped
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                    _c("div", [
                                                      _vm._v(
                                                        "TOTALI DA SPEDIRE: "
                                                      ),
                                                      _c("strong", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm
                                                                .totaliSpedizioni
                                                                .totResiduo
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                    ]),
                                                    _c("br"),
                                                  ])
                                                : _vm._e(),
                                              _vm.spedizione.note
                                                ? _c("div", [
                                                    _c("p", [
                                                      _vm._v(
                                                        "Note: " +
                                                          _vm._s(
                                                            _vm.spedizione.note
                                                          )
                                                      ),
                                                    ]),
                                                    _c("br"),
                                                  ])
                                                : _vm._e(),
                                              _c(
                                                "h3",
                                                {
                                                  staticClass: "text-truncate",
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.spedizione.stato
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm.spedizione.stato == "COMPLETA"
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticStyle: {
                                                        color: "white",
                                                        "margin-top": "10px",
                                                        "margin-bottom": "10px",
                                                      },
                                                      attrs: {
                                                        loading: _vm.csvLoading,
                                                        color:
                                                          "green lighten-2",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.downloadCSVPackingList,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Esporta packing list "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { right: "" },
                                                        },
                                                        [_vm._v("mdi-download")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.spedizione.stato == "COMPLETA"
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ml-3",
                                                      staticStyle: {
                                                        color: "white",
                                                        "margin-top": "10px",
                                                        "margin-bottom": "10px",
                                                      },
                                                      attrs: {
                                                        loading: _vm.csvLoading,
                                                        color:
                                                          "green lighten-2",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.downloadCSVPackingListExtended,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Esporta packing list esteso "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { right: "" },
                                                        },
                                                        [_vm._v("mdi-download")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c("v-spacer"),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c("v-card-title", [
                                _c("h2", [_vm._v("Righe spedizione")]),
                              ]),
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-card-title",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            "margin-top": "10px",
                                            "margin-bottom": "10px",
                                          },
                                          attrs: {
                                            color: _vm.barCodeAcquisitionMode
                                              ? "green lighten-2"
                                              : "red lighten-2",
                                          },
                                          on: { click: _vm.setAcquisitionMode },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticStyle: { color: "white" } },
                                            [
                                              _vm._v(
                                                "Aggiungi righe da barcode"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: { color: "white" },
                                              attrs: { right: "" },
                                            },
                                            [_vm._v("mdi-barcode")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            color: "white",
                                            "margin-top": "10px",
                                            "margin-left": "10px",
                                            "margin-bottom": "10px",
                                          },
                                          attrs: {
                                            disabled:
                                              _vm.isInBarCodeAcquisitionMode,
                                            color: "green lighten-2",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openAddLavorazioneManualmenteDialog()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(" Aggiungi riga manualmente "),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("mdi-magnify")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-dialog",
                                        {
                                          attrs: {
                                            "hide-overlay": "",
                                            width: "800",
                                          },
                                          model: {
                                            value: _vm.addRigaManualmenteDialog,
                                            callback: function ($$v) {
                                              _vm.addRigaManualmenteDialog = $$v
                                            },
                                            expression:
                                              "addRigaManualmenteDialog",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-title",
                                                {
                                                  staticClass:
                                                    "headline d-flex justify-space-between",
                                                },
                                                [
                                                  _vm._v(" Aggiungi riga "),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.addRigaManualmenteDialog = false
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("mdi-close")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass: "col-4",
                                                        attrs: {
                                                          label:
                                                            "Cerca Seriale EPC",
                                                        },
                                                        on: {
                                                          keyup: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              !$event.type.indexOf(
                                                                "key"
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "enter",
                                                                13,
                                                                $event.key,
                                                                "Enter"
                                                              )
                                                            )
                                                              return null
                                                            return _vm.addRigaFromEPC.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.epcSearchText,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.epcSearchText =
                                                              $$v
                                                          },
                                                          expression:
                                                            "epcSearchText",
                                                        },
                                                      }),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "pa-1",
                                                          attrs: {
                                                            size: "25",
                                                            color:
                                                              "grey lighten-1",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.addRigaFromEPC,
                                                          },
                                                        },
                                                        [_vm._v("mdi-magnify")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm.loadingRigaSpedizioneManualeDaLid
                                                    ? _c(
                                                        "v-row",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-row justify-center",
                                                        },
                                                        [
                                                          _c(
                                                            "v-progress-circular",
                                                            {
                                                              attrs: {
                                                                size: 50,
                                                                color:
                                                                  "primary",
                                                                indeterminate:
                                                                  "",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm.lavorazioneFound &&
                                                      _vm.lavorazioneFound.id
                                                    ? _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .lavorazioneFound
                                                                                  .codiceLAK
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                          _vm
                                                                            .lavorazioneFound
                                                                            .firstCost ==
                                                                          "S"
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    "USA"
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " Ordine N. "
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .lavorazioneFound
                                                                                .ordineNumero
                                                                            ) +
                                                                              " / " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .lavorazioneFound
                                                                                  .ordineLinea
                                                                              )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " del "
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.formatDateTime(
                                                                                _vm
                                                                                  .lavorazioneFound
                                                                                  .dataOrdine
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        ", Lotto: "
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .lavorazioneFound
                                                                                .lotto
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        ", Consegna: "
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .lavorazioneFound
                                                                                .codiceConsegna
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-list-item-subtitle",
                                                                    [
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .lavorazioneFound
                                                                                .campionario
                                                                                ? "CAMPIONARIO"
                                                                                : "PRODUZIONE"
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " Data scadenza: "
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.formatDateTime(
                                                                                _vm
                                                                                  .lavorazioneFound
                                                                                  .dataConsegna
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        ", Colore: "
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .lavorazioneFound
                                                                                .colore &&
                                                                                `${_vm.lavorazioneFound.colore.codiceColore} ${_vm.lavorazioneFound.colore.descrizione}`
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        ", Numero capi: "
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .lavorazioneFound
                                                                                .qtaTotale
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm
                                                                    .lavorazioneFound
                                                                    .datiAggiuntivi &&
                                                                  _vm
                                                                    .lavorazioneFound
                                                                    .datiAggiuntivi
                                                                    .length > 0
                                                                    ? _c(
                                                                        "v-list-item-subtitle",
                                                                        _vm._l(
                                                                          _vm
                                                                            .lavorazioneFound
                                                                            .datiAggiuntivi,
                                                                          function (
                                                                            da,
                                                                            i
                                                                          ) {
                                                                            return da.value
                                                                              ? _c(
                                                                                  "span",
                                                                                  {
                                                                                    key: da.name,
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          da.displayName
                                                                                        ) +
                                                                                        ": "
                                                                                    ),
                                                                                    da.metadataType ==
                                                                                    _vm
                                                                                      .metadataType
                                                                                      .Datetime
                                                                                      ? _c(
                                                                                          "strong",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                _vm.formatDateTime(
                                                                                                  da.value
                                                                                                )
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _c(
                                                                                          "strong",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                da.value
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e()
                                                                          }
                                                                        ),
                                                                        0
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-list-item-action",
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "white",
                                                                          "margin-top":
                                                                            "10px",
                                                                          "margin-left":
                                                                            "10px",
                                                                          "margin-bottom":
                                                                            "10px",
                                                                        },
                                                                      attrs: {
                                                                        color:
                                                                          "green lighten-2",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.addRigaSpedizione,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Aggiungi "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.spedizione.righe.length > 0
                                    ? _c("RigheSpedizioneList", {
                                        attrs: {
                                          spedizioni: _vm.spedizione.righe,
                                          compact: true,
                                        },
                                      })
                                    : _c(
                                        "v-alert",
                                        {
                                          attrs: { type: "info", value: true },
                                        },
                                        [
                                          _vm._v(
                                            " Non sono presenti righe per questa spedizione. "
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", [_vm._v(" Nessun dato da visualizzare. ")]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }